import {createDescriptionObjectForList, createListFromObject} from "../Utilities/Types/listUtilities";

export const jobTitles = [
    { jobID: 3, jobTitle: 'Charter School Employee' },
    { jobID: 6, jobTitle: 'College / University' },
    { jobID: 7, jobTitle: 'Community Partner / Non-Profit / Private Agency' },
    { jobID: 8, jobTitle: 'Department of Corrections' },
    { jobID: 9, jobTitle: 'Early Steps / Part C Agency' },
    { jobID: 10, jobTitle: 'FSDB (Florida School for the Deaf and the Blind)' },
    { jobID: 11, jobTitle: 'IDEA-Funded State Project' },
    { jobID: 1, jobTitle: 'Parent / Family Member (Non-professional)' },
    { jobID: 4, jobTitle: 'Private School Employee' },
    { jobID: 2, jobTitle: 'Public School District (FL County)' },
    { jobID: 5, jobTitle: 'RMTC-DHH' },
    { jobID: 12, jobTitle: 'State Agency (e.g., APD, VR, Department of Health)' },
];

// --- Parent / Family Member subtypes ---
export const PARENT_SUBTYPES = {
    Charter: createDescriptionObjectForList("3", "Charter"),
    Homeschool: createDescriptionObjectForList("1", "Home School"),
    Private: createDescriptionObjectForList("2", "Private"),
    Public: createDescriptionObjectForList("4", "Public"),
};
export const PARENT_SUBTYPES_LIST = createListFromObject(PARENT_SUBTYPES);

// --- Public School District subtypes ---
export const SCHOOL_DISTRICT_SUBTYPES = {
    DhhItinerantTeacher: createDescriptionObjectForList("15", "DHH Itinerant Teacher"),
    DhhSelfContainedTeacher: createDescriptionObjectForList("16", "DHH Self-Contained Teacher"),
    DhhSpecialist: createDescriptionObjectForList("17", "DHH Specialist/Program Specialist"),
    EducationalAudiologist: createDescriptionObjectForList("18", "Educational Audiologist"),
    EseDirector: createDescriptionObjectForList("5", "ESE Director/District Administrator"),
    EseTeacher: createDescriptionObjectForList("19", "ESE Teacher"),
    GeneralEducationTeacher: createDescriptionObjectForList("20", "General Education Teacher"),
    Interpreter: createDescriptionObjectForList("21", "Interpreter"),
    Lats: createDescriptionObjectForList("9", "LATS (Local Assistive Technology Specialist)"),
    Paraprofessional: createDescriptionObjectForList("7", "Paraprofessional/Intervener"),
    SchoolPsychologist: createDescriptionObjectForList("8", "School Counselor/Psychologist"),
    SpeechLanguagePathologist: createDescriptionObjectForList("22", "Speech-Language Pathologist (SLP)"),
    TransitionSpecialist: createDescriptionObjectForList("23", "Transition Specialist"),
};
export const SCHOOL_DISTRICT_SUBTYPES_LIST = createListFromObject(SCHOOL_DISTRICT_SUBTYPES);

// --- Charter School Employee subtypes ---
export const CHARTER_SCHOOL_SUBTYPES = {
    SchoolAdministrator: createDescriptionObjectForList("13", "Administration (Principal, Director)"),
    DhhItinerantTeacher: createDescriptionObjectForList("15", "DHH Itinerant Teacher"),
    DhhSelfContainedTeacher: createDescriptionObjectForList("16", "DHH Self-Contained Teacher"),
    EseTeacher: createDescriptionObjectForList("19", "ESE Teacher"),
    GeneralEducationTeacher: createDescriptionObjectForList("20", "General Education Teacher"),
    Interpreter: createDescriptionObjectForList("21", "Interpreter"),
    Paraprofessional: createDescriptionObjectForList("7", "Paraprofessional/Intervener"),
    SpeechLanguagePathologist: createDescriptionObjectForList("22", "Speech-Language Pathologist (SLP)"),
};
export const CHARTER_SCHOOL_SUBTYPES_LIST = createListFromObject(CHARTER_SCHOOL_SUBTYPES);

// --- Private School Employee subtypes ---
export const PRIVATE_SCHOOL_SUBTYPES = {
    DhhItinerantTeacher: createDescriptionObjectForList("15", "DHH Itinerant Teacher"),
    DhhSelfContainedTeacher: createDescriptionObjectForList("16", "DHH Self-Contained Teacher"),
    EseTeacher: createDescriptionObjectForList("19", "ESE Teacher"),
    GeneralEducationTeacher: createDescriptionObjectForList("20", "General Education Teacher"),
    Interpreter: createDescriptionObjectForList("21", "Interpreter"),
    SpeechLanguagePathologist: createDescriptionObjectForList("22", "Speech-Language Pathologist (SLP)"),
};
export const PRIVATE_SCHOOL_SUBTYPES_LIST = createListFromObject(PRIVATE_SCHOOL_SUBTYPES);

// --- College / University subtypes ---
export const COLLEGE_UNIVERSITY_SUBTYPES = {
    CollegeUniversityFaculty: createDescriptionObjectForList("11", "Faculty/Staff (College/University)"),
    Interpreter: createDescriptionObjectForList("21", "Interpreter"),
    CollegeUniversityStudent: createDescriptionObjectForList("10", "Student"),
};
export const COLLEGE_UNIVERSITY_SUBTYPES_LIST = createListFromObject(COLLEGE_UNIVERSITY_SUBTYPES);

// --- Early Steps / Part C Agency subtypes ---
export const EARLY_STEPS_SUBTYPES = {
    EarlyInterventionist: createDescriptionObjectForList("27", "Early Interventionist"),
    PartCCoordinator: createDescriptionObjectForList("28", "Part C Coordinator"),
    SpeechLanguagePathologist: createDescriptionObjectForList("22", "Speech-Language Pathologist (SLP)"),
};
export const EARLY_STEPS_SUBTYPES_LIST = createListFromObject(EARLY_STEPS_SUBTYPES);

// --- FSDB subtypes ---
export const FSDB_SUBTYPES = {
    FsdbAdministration: createDescriptionObjectForList("24", "FSDB Administration (President, Principal, Director)"),
    DhhSelfContainedTeacher: createDescriptionObjectForList("16", "DHH Self-Contained Teacher"),
    DhhSpecialist: createDescriptionObjectForList("17", "DHH Specialist/Program Specialist"),
    EducationalAudiologist: createDescriptionObjectForList("18", "Educational Audiologist"),
    Interpreter: createDescriptionObjectForList("21", "Interpreter"),
    Paraprofessional: createDescriptionObjectForList("7", "Paraprofessional/Intervener"),
    SpeechLanguagePathologist: createDescriptionObjectForList("22", "Speech-Language Pathologist (SLP)"),
    OccupationalTherapist: createDescriptionObjectForList("25", "Occupational Therapist"),
    PhysicalTherapist: createDescriptionObjectForList("26", "Physical Therapist"),
};
export const FSDB_SUBTYPES_LIST = createListFromObject(FSDB_SUBTYPES);

// --- IDEA-Funded State Project subtypes ---
export const IDEA_PROJECT_SUBTYPES = {
    AccessProject: createDescriptionObjectForList("29", "Access Project"),
    Arts4AllFlorida: createDescriptionObjectForList("30", "Arts4All Florida"),
    AuditoryOralEducationClarke: createDescriptionObjectForList("31", "Auditory-Oral Education Clarke Schools for Hearing and Speech"),
    AuditoryOralEducationMiami: createDescriptionObjectForList("32", "Auditory-Oral Education University of Miami Debbie School"),
    AutismTherapeuticWellness: createDescriptionObjectForList("33", "Autism Therapeutic Wellness Program"),
    BridgeToSpeechClarke: createDescriptionObjectForList("34", "Bridge to Speech Clarke Schools for Hearing and Speech"),
    BridgeToSpeechMiami: createDescriptionObjectForList("35", "Bridge to Speech University of Miami Debbie School"),
    Card: createDescriptionObjectForList("36", "Center for Autism and Related Disabilities (CARD)"),
    Chris: createDescriptionObjectForList("37", "Children's Registry and Information System (CHRIS)"),
    CiviFsuFlvi: createDescriptionObjectForList("38", "Critical Initiatives in Visual Impairment (CIVI-FSU) and the Florida Low Vision Initiative (FLVI)"),
    Eip: createDescriptionObjectForList("39", "Educational Interpreter Project (EIP)"),
    EseTuitionSupport: createDescriptionObjectForList("40", "Exceptional Student Education (ESE) Tuition Support"),
    FamilyCafe: createDescriptionObjectForList("41", "Family Café (Cooperation, Advocacy, Friendship and Empowerment)"),
    FdlrsACs: createDescriptionObjectForList("42", "Florida Diagnostic and Learning Resources System Associate Centers (FDLRS ACs)"),
    FdlrsAdministration: createDescriptionObjectForList("43", "FDLRS Administration"),
    FdlrsMDCs: createDescriptionObjectForList("44", "FDLRS Multidisciplinary Educational Service Centers (FDLRS MDCs)"),
    FdlrsRlats: createDescriptionObjectForList("45", "FDLRS Regional Local Assistive Technology Support (FDLRS RLATS)"),
    Fin: createDescriptionObjectForList("46", "FIN"),
    FimcVi: createDescriptionObjectForList("47", "Florida Instructional Materials Center for the Visually Impaired (FIMC-VI)"),
    FlpbisMtss: createDescriptionObjectForList("48", "Florida Positive Behavioral Interventions and Support Project: Multi-Tiered System of Supports (FLPBIS: MTSS)"),
    IsrdC: createDescriptionObjectForList("49", "Institute for Small and Rural Districts and Compliance (ISRD-C)"),
    Ltl: createDescriptionObjectForList("50", "Learning Through Listening (LTL)"),
    MiamiLighthouseAcademy: createDescriptionObjectForList("51", "Miami Lighthouse Academy"),
    Sednet: createDescriptionObjectForList("52", "Multiagency Network for Students with Emotional or Behavioral Disabilities (SEDNET)"),
    SednetAdministration: createDescriptionObjectForList("53", "SEDNET Administration"),
    Pepsa: createDescriptionObjectForList("54", "Partnership for Effective Programs for Students with Autism (PEPSA)"),
    Pdsp: createDescriptionObjectForList("55", "Personnel Development Support Project (PDSP)"),
    PsRtI: createDescriptionObjectForList("56", "Problem Solving and Response to Intervention (PS/RtI)"),
    PsRtITlc: createDescriptionObjectForList("57", "PS/RtI Technology and Learning Connections (TLC)"),
    Pese: createDescriptionObjectForList("58", "Prekindergarten Exceptional Student Education Technical Assistance and Training System (PESE)"),
    Project10: createDescriptionObjectForList("59", "Project 10: Transition Education Network (Project 10)"),
    RmtcDhh: createDescriptionObjectForList("60", "Resource Materials and Technology Center for the Deaf/Hard of Hearing (RMTC-DHH)"),
    SpecialOlympicsFlorida: createDescriptionObjectForList("61", "Special Olympics, Florida"),
    SssProject: createDescriptionObjectForList("62", "Student Support Services (SSS) Project"),
    Wwe: createDescriptionObjectForList("63", "Working with the Experts (WWE)"),
};
export const IDEA_PROJECT_SUBTYPES_LIST = createListFromObject(IDEA_PROJECT_SUBTYPES);

// --- RMTC-DHH subtypes ---
export const RMTC_SUBTYPES = {
    Administrator: createDescriptionObjectForList("6", "Administrator"),
    StaffMember: createDescriptionObjectForList("12", "Staff Member"),
};
export const RMTC_SUBTYPES_LIST = createListFromObject(RMTC_SUBTYPES);

// --- Roles without subtypes (auto-assigned None=26) ---
// Community Partner, Department of Corrections, State Agency

export const createSubtypeListFromPatronRole = (jobTitle: number | string) => {
    switch (Number(jobTitle)) {
        case 1:
            return PARENT_SUBTYPES_LIST;
        case 2:
            return SCHOOL_DISTRICT_SUBTYPES_LIST;
        case 3:
            return CHARTER_SCHOOL_SUBTYPES_LIST;
        case 4:
            return PRIVATE_SCHOOL_SUBTYPES_LIST;
        case 5:
            return RMTC_SUBTYPES_LIST;
        case 6:
            return COLLEGE_UNIVERSITY_SUBTYPES_LIST;
        case 9:
            return EARLY_STEPS_SUBTYPES_LIST;
        case 10:
            return FSDB_SUBTYPES_LIST;
        case 11:
            return IDEA_PROJECT_SUBTYPES_LIST;
        default:
            return [];
    }
};

export const PatronRoleSubtypesMap = [
    { value: 'Homeschool', key: 1 },
    { value: 'Private', key: 2 },
    { value: 'Charter', key: 3 },
    { value: 'Public', key: 4 },
    { value: 'ESE Director/District Administrator', key: 5 },
    { value: 'Administrator', key: 6 },
    { value: 'Paraprofessional/Intervener', key: 7 },
    { value: 'School Counselor/Psychologist', key: 8 },
    { value: 'LATS (Local Assistive Technology Specialist)', key: 9 },
    { value: 'Student', key: 10 },
    { value: 'Faculty/Staff (College/University)', key: 11 },
    { value: 'Staff Member', key: 12 },
    { value: 'Administration (Principal, Director)', key: 13 },
    { value: 'None', key: 14 },
    { value: 'DHH Itinerant Teacher', key: 15 },
    { value: 'DHH Self-Contained Teacher', key: 16 },
    { value: 'DHH Specialist/Program Specialist', key: 17 },
    { value: 'Educational Audiologist', key: 18 },
    { value: 'ESE Teacher', key: 19 },
    { value: 'General Education Teacher', key: 20 },
    { value: 'Interpreter', key: 21 },
    { value: 'Speech-Language Pathologist (SLP)', key: 22 },
    { value: 'Transition Specialist', key: 23 },
    { value: 'FSDB Administration (President, Principal, Director)', key: 24 },
    { value: 'Occupational Therapist', key: 25 },
    { value: 'Physical Therapist', key: 26 },
    { value: 'Early Interventionist', key: 27 },
    { value: 'Part C Coordinator', key: 28 },
    { value: 'Access Project', key: 29 },
    { value: 'Arts4All Florida', key: 30 },
    { value: 'Auditory-Oral Education Clarke Schools for Hearing and Speech', key: 31 },
    { value: 'Auditory-Oral Education University of Miami Debbie School', key: 32 },
    { value: 'Autism Therapeutic Wellness Program', key: 33 },
    { value: 'Bridge to Speech Clarke Schools for Hearing and Speech', key: 34 },
    { value: 'Bridge to Speech University of Miami Debbie School', key: 35 },
    { value: 'Center for Autism and Related Disabilities (CARD)', key: 36 },
    { value: "Children's Registry and Information System (CHRIS)", key: 37 },
    { value: 'Critical Initiatives in Visual Impairment (CIVI-FSU) and the Florida Low Vision Initiative (FLVI)', key: 38 },
    { value: 'Educational Interpreter Project (EIP)', key: 39 },
    { value: 'Exceptional Student Education (ESE) Tuition Support', key: 40 },
    { value: 'Family Café (Cooperation, Advocacy, Friendship and Empowerment)', key: 41 },
    { value: 'Florida Diagnostic and Learning Resources System Associate Centers (FDLRS ACs)', key: 42 },
    { value: 'FDLRS Administration', key: 43 },
    { value: 'FDLRS Multidisciplinary Educational Service Centers (FDLRS MDCs)', key: 44 },
    { value: 'FDLRS Regional Local Assistive Technology Support (FDLRS RLATS)', key: 45 },
    { value: 'FIN', key: 46 },
    { value: 'Florida Instructional Materials Center for the Visually Impaired (FIMC-VI)', key: 47 },
    { value: 'Florida Positive Behavioral Interventions and Support Project: Multi-Tiered System of Supports (FLPBIS: MTSS)', key: 48 },
    { value: 'Institute for Small and Rural Districts and Compliance (ISRD-C)', key: 49 },
    { value: 'Learning Through Listening (LTL)', key: 50 },
    { value: 'Miami Lighthouse Academy', key: 51 },
    { value: 'Multiagency Network for Students with Emotional or Behavioral Disabilities (SEDNET)', key: 52 },
    { value: 'SEDNET Administration', key: 53 },
    { value: 'Partnership for Effective Programs for Students with Autism (PEPSA)', key: 54 },
    { value: 'Personnel Development Support Project (PDSP)', key: 55 },
    { value: 'Problem Solving and Response to Intervention (PS/RtI)', key: 56 },
    { value: 'PS/RtI Technology and Learning Connections (TLC)', key: 57 },
    { value: 'Prekindergarten Exceptional Student Education Technical Assistance and Training System (PESE)', key: 58 },
    { value: 'Project 10: Transition Education Network (Project 10)', key: 59 },
    { value: 'Resource Materials and Technology Center for the Deaf/Hard of Hearing (RMTC-DHH)', key: 60 },
    { value: 'Special Olympics, Florida', key: 61 },
    { value: 'Student Support Services (SSS) Project', key: 62 },
    { value: 'Working with the Experts (WWE)', key: 63 },
];

export const JOB_ROLES = {
    Parent: '1',
    District: '2',
    Charter: '3',
    Private: '4',
    Rmtc: '5',
    CollegeUniversity: '6',
    CommunityPartner: '7',
    DepartmentOfCorrections: '8',
    EarlyStepsPartCAgency: '9',
    Fsdb: '10',
    IdeaFundedStateProject: '11',
    StateAgency: '12',
};

export const ROLES_WITHOUT_SUBTYPES = [
    JOB_ROLES.CommunityPartner,
    JOB_ROLES.DepartmentOfCorrections,
    JOB_ROLES.StateAgency,
];
  
